import { Search } from 'angular2-multiselect-dropdown/lib/menu-item';
import { Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild, forwardRef, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject, finalize, Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { PricePlanService } from '../../Price-subscritions/priceplanService';
// Direct import. NewJobComponent transitively imports this component, so
// the import cycle is broken with `forwardRef(() => NewJobComponent)` in
// the @Component imports array — same pattern as talent-pool.component.ts.
import { NewJobComponent } from 'src/app/page/homepage/layout-jobs/new-job/new-job.component';
import { CandidateService } from 'src/app/services/CandidateService';
import { ApiService } from 'src/app/services/api.service';
import { JobModel } from 'src/app/services/jobModel';
import { UtilService } from 'src/app/services/util.service';
import { AppSettings } from 'src/app/services/AppSettings';
import Swal from 'sweetalert2';
import { countProvider } from '../../suggestions/suggestions.component';
import { CommonModule } from '@angular/common';
import { CommonSkeletonComponent } from 'src/app/skeleton/common-skeleton/common-skeleton.component';
import { CandidateJobDetailsComponent } from '../../candidate-job-details/candidate-job-details.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CandidateCardComponent } from '../../cards/candidate-card/candidate-card.component';
import { CandidateCardTableViewComponent } from '../candidate-card-table-view/candidate-card-table-view.component';
import { CandidateDocumentsComponent } from '../candidate-documents/candidate-documents.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


import { ScrollIntentGate } from 'src/app/shared/scroll-intent-gate';
@Component({
  selector: 'app-resume-request-sent',
  standalone: true,
  imports: [
    CommonModule,
    CommonSkeletonComponent,
CandidateJobDetailsComponent,
    InfiniteScrollModule,
    CandidateCardComponent,
    CandidateCardTableViewComponent,
    CandidateDocumentsComponent
  ,
    NG_ICON_DIRECTIVES,
    forwardRef(() => NewJobComponent),
  ],
  templateUrl: './resume-request-sent.component.html',
  styleUrls: ['./resume-request-sent.component.scss'],

})
export class ResumeRequestSentComponent implements OnDestroy, OnInit,OnChanges {
  // User-intent gate (src/app/shared/scroll-intent-gate.ts): after a page
  // lands, the next page needs a NEW physical input — a fast wheel flick's
  // smooth-scroll tail must not chain pages on its own.
  readonly scrollGate = new ScrollIntentGate({
    onArmAtBottom: () => this.onScrollDown(),
    isAtBottom: () => ScrollIntentGate.nearBottom(document.querySelector('.jc-v3-entity-details-body')),
  });

  ngOnDestroy(): void {
    this.scrollGate.detach();
  }

  @Input() designVersion: string = 'v2';
  page: any;
  @Input() pagelist: string;
  @Input() jobDetails: any;
  @Input() maxMin: any = {};
  viewType: string = "MIN";
  passValues: any = []
  Resumerequeststatus: any;
  stopscrollFlag = false;
  responseReceived: boolean = false;
  constructor(private canidateService: CandidateService, private apiService: ApiService,
    private provider :countProvider , private util: UtilService,
    private planService: PricePlanService, private bsModalService: BsModalService) { }
  resumeRequestedUserList = new BehaviorSubject<any>([]);
  resumeRequestedPreviouseSearchAfterKey : string ;
  resumeRequestedStopScroll : boolean = false;

  loadAPIcall:boolean=false;
  URL = "candidates/findResumeRequestByTheUser";
  totalCount: number = 0;
  obj: any = {
    limit: 10,
    searchAfterKey: null,
    userId: localStorage.getItem('userId')
  }
  data: any = {
    limit: 10,
    searchAfterKey: null,
    userId: localStorage.getItem('userId')
  };

  payload() {
    this.data = {
      limit: 10,
      jobId: this.jobDetails.jobId,
      searchAfterKey: null,
      userId: localStorage.getItem('userId')
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.maxMin && changes.maxMin.currentValue) {
      this.maxMin = changes.maxMin.currentValue;
      if (this.maxMin.viewType) {
        this.viewType = this.maxMin.viewType;
      }
    }
    if (changes.jobDetails&&changes.jobDetails.currentValue) {
      this.jobDetails = changes.jobDetails.currentValue;
      if (this.jobDetails.jobId&&this.pagelist == 'resume-requests') {
        // Invalidate any in-flight page fetch and unlock the loadAPIcall
        // entry guard — otherwise a tab re-click during pagination skips
        // the reload and the stale page lands in the cleared list.
        this.fetchGeneration++;
        this.loadAPIcall = false; this.scrollGate.pageLanded();
        this.priviousSearchafterKey = null;
        this.data.searchAfterKey=null;
          this.passValues = [];
          this.payload();
          this.insideresumerequestsent()
      }
    }
  }

  ngOnInit() {


    this.scrollGate.attach();
    if (this.maxMin && this.maxMin.viewType) {
      this.viewType = this.maxMin.viewType;
    }
    if (this.pagelist != 'resume-requests') {
      this.apiCall();
    }
    this.passValues = [];

    this.scrollSubject.pipe(
      debounceTime(100)
    ).subscribe(() => {
      if (this.loadAPIcall) return;
      if (this.pagelist === 'resume-requests') {
        if (!this.stopscrollFlag && this.data.searchAfterKey != this.priviousSearchafterKey) {
          this.insideresumerequestsent();
        }
      } else {
        if (!this.resumeRequestedStopScroll && this.obj.searchAfterKey != this.resumeRequestedPreviouseSearchAfterKey) {
          this.obj.searchAfterKey = this.resumeRequestedPreviouseSearchAfterKey;
          this.apiCall();
        }
      }
    });
  }

  apiCall() {
    this.loadAPIcall=true;
    this.canidateService.getResumeRequestedUsers(this.obj).subscribe((response: any) => {
      this.loadAPIcall = false; this.scrollGate.pageLanded();
      if (response) {
        const afterKey = response.searchAfterKey;
        const responseData = response.resumeRequests;

        if(responseData){

          if(this.resumeRequestedPreviouseSearchAfterKey === afterKey || responseData.length === 0){
            this.resumeRequestedStopScroll = true;
          }

          const data = responseData.map((request) => {
            // Note: Do NOT add photoUrl prefix here - candidate-job-details template already adds it via downloadurl
            const result = {
              candidateEntity: {
                ...request.candidateEntity,
                user: request.user
              },
              currentStatus : request.currentStatus,
              user: request.user,
              jobDetails : request.jobDetails
            };

            return result;
          });
          if (this.resumeRequestedPreviouseSearchAfterKey !== afterKey) {
          const combinedResponse = [...this.resumeRequestedUserList.getValue() , ...data ];
          this.resumeRequestedUserList.next(combinedResponse);

          }
          this.resumeRequestedPreviouseSearchAfterKey = afterKey;



          if (response.total != 0) {
            this.totalCount = response.total;
            this.provider.setCount(this.totalCount , "ResumeRequestSentComponent");
          }

        }

      }



    }, err=>{

      this.loadAPIcall = false; this.scrollGate.pageLanded();

    });
  }
  priviousSearchafterKey: any = null;
  // Stale-response gate: bumped on every list reset (tab re-click). A fetch
  // captures the value at launch; a reset mid-flight makes the late response
  // a no-op instead of appending old rows into the cleared list.
  private fetchGeneration = 0;

  insideresumerequestsent() {
    // Prevent duplicate API calls on rapid clicks (e.g., double-click)
    if (this.loadAPIcall) {
      return;
    }
    this.responseReceived = false;
    this.loadAPIcall=true
    const gen = this.fetchGeneration;

    if (this.data.searchAfterKey != null) {
      this.priviousSearchafterKey = this.data.searchAfterKey;
    }

    this.apiService.create("candidates/findResumeRequestsForTheJob", this.data).subscribe((res) => {
      if (gen !== this.fetchGeneration) return;

      this.loadAPIcall = false; this.scrollGate.pageLanded();if (res && res.code == '00000' && res.data.rewsumeRequestedCandidates) {
        this.responseReceived = true;

        if (res.data.rewsumeRequestedCandidates.length == 0) {
          // A full last page (9–10 items) advances the cursor, so the end of
          // the list arrives as this empty follow-up page — flag it, or the
          // "You've reached the bottom" footer never shows for those counts.
          this.stopscrollFlag = true;
          if (this.passValues.length === 0) {
            this.Resumerequeststatus = "There are no Resume request for this job";
          }
          return true;
        }

        if (res.data.rewsumeRequestedCandidates && res.data.rewsumeRequestedCandidates.length < 9) {
          this.stopscrollFlag = true;
        } else {
          this.stopscrollFlag = false;
          this.data.searchAfterKey = res.data.searchAfterKey;
        }

      //   const newElements = res.data.rewsumeRequestedCandidates.filter(element =>
      //     !this.passValues.some(el => el.id === element.id)
      // );

      this.passValues = this.passValues.concat(res.data.rewsumeRequestedCandidates);

      // remove throwMatDuplicatedDrawerError

      // this.passValues = this.passValues.filter((value, index, self) =>
      //   index === self.findIndex((t) => t.id === value.id)
      // );


      } else if (res.code == "99999") {
        this.Resumerequeststatus = 'Something went wrong, please try after some time.';
      }
    });
  }

  // ── Invite to Apply (V3 row button) ──────────────────────────────
  // Same flow as talent-pool.component.ts:570 — plan-check via
  // ACTIVE_INTERACTIONS, then open the invite-job-listing modal
  // (nested app-new-job) so the recruiter picks the job(s) to invite
  // the resume-requested candidate to.
  @ViewChild('jobsupplytemplate') jobSupplyTemplate: TemplateRef<any>;
  candidateSupplyRef: BsModalRef;
  isClicked: boolean = false;
  candidateData: any;
  focus: string;

  invite(values: any) {
    if (this.isClicked) {
      return;
    }
    this.util.startLoader();
    this.isClicked = true;
    this.candidateData = values;
    this.focus = 'candidate';
    this.proceedToInvite(values, this.jobSupplyTemplate);
    setTimeout(() => {
      this.isClicked = false;
    }, 5000);
  }

  async proceedToInvite(values, jobsupplytemplate) {
    this.util.startLoader();
    const userData = await this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
    let { membershipType } = userData;
    if (userData.isExpired) {
      this.util.stopLoader();
      let availablePoints = null;
      let actualPoints = null;
      let utilizedPoints = null;
      let promotional = null;
      userData.userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
        if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
          this.util.stopLoader();
          availablePoints = ele.available
          actualPoints = ele.actual
          utilizedPoints = ele.utilized
          promotional = ele.promotional
        }
      })
      let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";
      if (['Starter','Growth','ScaleX'].includes(membershipType)) {
        popupType = "LIMIT";
      }
      this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null, null, availablePoints, actualPoints, utilizedPoints, promotional);
      return;
    }
    values.userId = localStorage.getItem('userId');
    values.candidatefilter = true;
    values.getResume = false;
    values.userType = values.user ? values.user.userType : null;
    const config: ModalOptions = { class: 'modal-lg', backdrop: 'static', keyboard: false };
    this.candidateSupplyRef = this.bsModalService.show(jobsupplytemplate, config);
    this.util.stopLoader();
  }

  closeJobSupplyModal() {
    if (this.candidateSupplyRef) {
      this.candidateSupplyRef.hide();
    }
  }

  // Intentional no-op — same rationale as candiates-invited.downloadResume.
  // The child `app-candidate-card-table-view` owns the resume-download
  // flow end-to-end (plan-check via ACTIVE_INTERACTIONS, then registered
  // blob download via `candidates/resumeDownload/...`). The previous
  // body here opened `AppSettings.ServerUrl + 'download/' + fileId`
  // which (a) bypasses plan-gating and (b) uses a download endpoint
  // that diverges from the registered flow, producing double-open +
  // potential 404 depending on deployment. Leave body empty — child
  // handles everything.
  downloadResume(candidate: any): void {
    // No-op on purpose. See comment above.
  }

  scrollSubject = new Subject<void>();
  onScrollDown() {
    if (!this.loadAPIcall && !this.stopscrollFlag && this.scrollGate.armed) {
      this.scrollSubject.next();
    }
  }

  onScrollResume() {
    if (!this.loadAPIcall && !this.resumeRequestedStopScroll && this.scrollGate.armed) {
      this.scrollSubject.next();
    }
  }


  pagecount(event) {
    this.page = event;
    this.obj.pageNumber = this.page - 1;
    this.apiCall();
  }

  // ── Status update from V3 row dropdown (owner-gated upstream) ────
  // Mirrors the canonical flow in job-applicants.component.ts:1209.
  // Triggered when a resume-requested candidate progresses into the
  // applicant pipeline and the recruiter wants to move them along
  // without leaving this tab.
  updateStatus(statusData: any, candidate: any) {
    const status = statusData?.itemId || statusData;
    if (!status || !candidate?.candidateId) return;
    this.util.startLoader();
    const data: any = {
      candidateId: candidate.candidateId,
      jobId: this.jobDetails?.jobId,
      currentStatus: status,
      candidateName: [candidate?.firstName, candidate?.lastName].filter(Boolean).join(' ').trim(),
      jobTitle: this.jobDetails?.jobTitle || candidate?.jobTitle || '',
      createdByUserName: this.jobDetails?.postedByUserName || '',
      createdBy: candidate?.createdBy || '',
      email: candidate?.user?.email || candidate?.email || '',
    };
    this.apiService.create('candidates/updatejobAppliedStatus', data).subscribe(
      (res: any) => {
        this.util.stopLoader();
        if (res.code == '00000') {
          Swal.fire({ position: 'center', icon: 'success', title: 'Status successfully Updated.', showConfirmButton: false, timer: 2000 });
          candidate.currentStatus = status;
        } else if (res.code == '99998') {
          Swal.fire('Please complete the document verification process', '', 'info');
        } else {
          Swal.fire({ icon: 'error', title: 'Status update failed', text: res?.message || 'The candidate status could not be updated.', showConfirmButton: true });
        }
      },
      () => {
        this.util.stopLoader();
        Swal.fire({ icon: 'error', title: 'Status update failed', text: 'Network error.', showConfirmButton: true });
      }
    );
  }

  // ── Documents slider (V3 documents icon on OFFER-ACCEPTED+ rows) ─
  // Same pattern as job-applicants:1862. The Documents button only
  // renders when the candidate has progressed into offer/onboarding
  // statuses, so this scaffold is conditional but real.
  showDocumentSection: boolean = false;
  selectedCandidateForDocument: any;
  totalMandatoryDocuments: any;
  allVerified: any;

  typeOfDocuments = [
    { name: 'Resume', mandatory: false, isUploaded: true, documents: [], headers: [] },
    { name: 'Drivers License', mandatory: false, isUploaded: true, documents: [] },
    { name: 'Employment Authorization Document', mandatory: false, isUploaded: false, documents: [] },
    { name: 'Passport', mandatory: false, isUploaded: false, documents: [] },
    { name: 'Visa', mandatory: false, isUploaded: false, documents: [] },
    { name: 'I-94', mandatory: false, isUploaded: false, documents: [] },
    { name: 'Background Check Certification', mandatory: false, isUploaded: false, documents: [] },
    { name: 'Background Verification', mandatory: false, isUploaded: false, documents: [] },
    { name: 'Drug Screening', mandatory: false, isUploaded: false, documents: [] }
  ];

  documentsRequired = {
    jobId: '', candidateId: '',
    resumeMandatory: '', driversLicenseMandatory: '', employmentAuthorizationMandatory: '',
    passportMandatory: '', visaMandatory: '', i94Mandatory: '',
    backgroundCheckstatusMandatory: '', backgroundCheckCertificateMandatory: '',
    drugScreenMandatory: '', conversationKey: 'SENDER'
  };

  openDocuments(cand: any) {
    if (!cand?.candidateId) return;
    // Clear the previous candidate's documents BEFORE the slider renders.
    // `typeOfDocuments` is a single shared array reused for every candidate,
    // and getSavedRequiredDocuments() repopulates it in place asynchronously
    // (and bails when the candidate has no saved config). Without this reset
    // the slider would show the last candidate's documents during the fetch,
    // and keep showing them entirely when the new candidate has none.
    this.resetTypeOfDocuments();
    this.showDocumentSection = true;
    this.selectedCandidateForDocument = cand;
    this.getSavedRequiredDocuments(cand.candidateId);
  }

  /** Blank out the shared document buckets + header counts so the slider
   *  starts clean for whichever candidate is opened next. */
  resetTypeOfDocuments() {
    for (const doc of this.typeOfDocuments) {
      doc.mandatory = false;
      doc.documents = [];
    }
    this.totalMandatoryDocuments = 0;
    this.allVerified = false;
  }

  closeDocuments() {
    this.showDocumentSection = false;
    this.selectedCandidateForDocument = null;
  }

  refreshDocumentData() {
    if (this.selectedCandidateForDocument) {
      this.getSavedRequiredDocuments(this.selectedCandidateForDocument.candidateId);
    }
  }

  saveDocuments(value: any) {
    this.documentsRequired.jobId = this.jobDetails.jobId;
    this.documentsRequired.candidateId = this.selectedCandidateForDocument.candidateId;
    this.documentsRequired.resumeMandatory = value.find(e => e.name === 'Resume')?.mandatory ?? false;
    this.documentsRequired.driversLicenseMandatory = value.find(e => e.name === 'Drivers License')?.mandatory ?? false;
    this.documentsRequired.employmentAuthorizationMandatory = value.find(e => e.name === 'Employment Authorization Document')?.mandatory ?? false;
    this.documentsRequired.passportMandatory = value.find(e => e.name === 'Passport')?.mandatory ?? false;
    this.documentsRequired.visaMandatory = value.find(e => e.name === 'Visa')?.mandatory ?? false;
    this.documentsRequired.i94Mandatory = value.find(e => e.name === 'I-94')?.mandatory ?? false;
    this.documentsRequired.backgroundCheckstatusMandatory = value.find(e => e.name === 'Background Verification')?.mandatory ?? false;
    this.documentsRequired.backgroundCheckCertificateMandatory = value.find(e => e.name === 'Background Check Certification')?.mandatory ?? false;
    this.documentsRequired.drugScreenMandatory = value.find(e => e.name === 'Drug Screening')?.mandatory ?? false;

    this.util.startLoader();
    this.apiService.create('jobs/requestMandatoryDocuments', this.documentsRequired)
      .pipe(finalize(() => this.util.stopLoader()))
      .subscribe({
        next: (res: any) => {
          if (res.code === '00000') {
            this.showDocumentSection = false;
            Swal.fire({ title: 'Required documents updated successfully', icon: 'success', showConfirmButton: false, timer: 2000 });
            this.getSavedRequiredDocuments(value.candidateId);
          } else {
            Swal.fire('', res?.message || 'Something went wrong', 'error');
          }
        },
        error: () => Swal.fire('Something went wrong', '', 'error')
      });
  }

  getSavedRequiredDocuments(candId: any) {
    const payload = { jobId: this.jobDetails.jobId, candidateId: candId };
    this.util.startLoader();
    this.apiService.create('jobs/getContractDocumentDetails', payload)
      .pipe(finalize(() => this.util.stopLoader()))
      .subscribe({
        next: (res: any) => {
          const config = res.data?.existingConfig;
          if (!config) return;
          for (const doc of this.typeOfDocuments) {
            switch (doc.name) {
              case 'Resume':                              doc.mandatory = config.resumeMandatory;                       doc.documents = config?.resumeDocuments || []; break;
              case 'Drivers License':                     doc.mandatory = config.driversLicenseMandatory;               doc.documents = config?.driversLicenseDocuments || []; break;
              case 'Employment Authorization Document':   doc.mandatory = config.employmentAuthorizationMandatory;      doc.documents = config?.employmentAuthorizationDocuments || []; break;
              case 'Passport':                            doc.mandatory = config.passportMandatory;                     doc.documents = config?.passportDocuments || []; break;
              case 'Visa':                                doc.mandatory = config.visaMandatory;                         doc.documents = config?.visaDocuments || []; break;
              case 'I-94':                                doc.mandatory = config.i94Mandatory;                          doc.documents = config?.i94Documents || []; break;
              case 'Background Verification':             doc.mandatory = config.backgroundCheckstatusMandatory;        doc.documents = config?.backgroundCheckDocuments || []; break;
              case 'Background Check Certification':      doc.mandatory = config.backgroundCheckCertificateMandatory;   doc.documents = config?.backgroundCheckCertificationDocuments || []; break;
              case 'Drug Screening':                      doc.mandatory = config.drugScreenMandatory;                   doc.documents = config?.drugScreenDocuments || []; break;
            }
          }
          const allVerified = res?.data?.documentProgress?.allMandatoryVerified;
          this.totalMandatoryDocuments = allVerified
            ? (res?.data?.documentProgress?.totalVerifiedCount ?? 0)
            : (res?.data?.documentProgress?.headerCount ?? 0);
          this.allVerified = allVerified;
        },
        error: (err: any) => console.error('Error fetching document details', err)
      });
  }

}
